import { EFFECTS, ACID_MODES } from "@/effects";

export const ModeList = ({ activeId, showAcid, onSelect }) => (
  <nav className="hud hud-modes" aria-label="Modes" data-testid="mode-list">
    <span className="ml-label">modes</span>
    <ul>
      {EFFECTS.map((e, i) => (ACID_MODES.includes(e.id) && !showAcid ? null : (
        <li key={e.id}>
          <button className="ml-item" data-active={e.id === activeId} aria-current={e.id === activeId} onClick={() => onSelect(i)}
            data-testid={`mode-list-item-${e.id}`}>
            <span className="ml-dot" />{e.name}
          </button>
        </li>
      )))}
    </ul>
  </nav>
);
